import { isTrackStems } from './TrackStems';
export function isTrackPart(x) {
    return x != null && typeof x.start == 'number' &&
        (typeof x.stem == 'string') &&
        (typeof x.passes == 'number');
}
export function isTrack(x) {
    return x != null &&
        (typeof x.stems == 'object') && isTrackStems(x.stems) &&
        (Array.isArray(x.parts) && x.parts.every(isTrackPart));
}
//# sourceMappingURL=Track.js.map